import { Request, Response } from 'kts-scaffold-framework/server';
import { CallType } from 'kts-scaffold-framework/utils/ajax';
import { Urls } from 'kts-platform-frame/entry/constant';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import ApiBasic from 'kts-platform-frame/api/ApiBasic';
import IOptions from './IOptions';

/**
 * 切换公司
 * Switching
 */
class Switching extends ApiBasic<IOptions, undefined> {

    /** 入口 */
    public async api(option: IOptions): Promise<Response<undefined>> {

        const user = MyStore.instance.getState().user;
        const request = new Request(CallType.POST, Urls.AUTH_CWEB_LOGIN, option);
        
        request.options['x-kxl-app-key'] = 'Kingxunlian.CompanySwitch'; 

        const data: Response<any> = await this.callAjax(request);
        if (data.er) {
            return data;
        }

        user.cToken = data.res.token;
        user.currentcompanyId = option.companyId;

        await MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, user);
        
        return new Response(null);
    }
}

export default new Switching().run;



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/api/company/switching/index.ts